/**
 * "Viewing as <account>" banner (WP-P6). Mounted once by the app shell so it
 * is impossible to forget you are inside another tenant's data — the audit's
 * main objection to the header-only impersonation mechanism.
 */
import { useIntl } from 'react-intl'
import { Eye, X } from 'lucide-react'
import { getImpersonation, stopImpersonation } from './impersonation'

export default function ImpersonationBanner() {
  const intl = useIntl()
  const active = getImpersonation()
  if (!active) return null

  return (
    <div
      role="status"
      className="flex items-center gap-2 px-4 py-1.5 bg-amber-100 text-amber-900 border-b border-amber-300 text-sm"
    >
      <Eye className="w-4 h-4 shrink-0" aria-hidden />
      <span className="min-w-0 truncate">
        {intl.formatMessage(
          { id: 'platform.viewingAs', defaultMessage: 'Viewing as {account} — every action is written to that account.' },
          { account: active.name },
        )}
      </span>
      <button
        type="button"
        onClick={() => stopImpersonation()}
        className="ml-auto inline-flex items-center gap-1 rounded px-2 py-0.5 font-medium hover:bg-amber-200 focus-ring shrink-0"
      >
        <X className="w-3.5 h-3.5" aria-hidden />
        {intl.formatMessage({ id: 'platform.exitImpersonation', defaultMessage: 'Exit' })}
      </button>
    </div>
  )
}
